import React from 'react'
import { useState , useEffect  } from 'react'

import axios from 'axios';

import getGlobal from '../../setglobal';
import ShowEspecifications from './ShowEspecifications';
import ShowFeatures from './ShowFeatures';

import {faXmarkCircle} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'




export default function ShowGeneral({showProduct,disable,setClose}) {

  const  [fullData,setFullData] = useState([]) ;

  useEffect(()=>{

    console.log( "Llamando a useEfect " + showProduct.sku) ;

    console.log( getGlobal() + "getproductdetail/?sku=" + showProduct.sku ) ;

    axios.get( getGlobal() + "getproductdetail/?sku=" + showProduct.sku  )
    .then((response) =>{

        console.log( "Resultado")
        console.log( response.data ) ;

        if ( response.data.length === 0 )
        {
          console.log( "No encontramos nada") ;
          disable({status:false} )

          return ;

        }

        console.log( "price = " + response.data.price ) ;
        console.log( "titlesp = " + response.data.titlesp ) ;

        if ( ( 'warranty' in response.data ) === false )
        {
          response.data.warranty = "" ;
        } 

        setFullData( response.data ) ;

    })
    .catch((err) => {
        console.log( err ) ;

    })




  } , [showProduct])


function getDecimals( n )
  {
    var p = n.toString() ;


    //console.log( p ) ;

    var v = p.indexOf(".") ;

    p = p.substring( 0 , v + 3 )

    if ( v > 3 )
    {
      //1999.00

      var index = 2 ;

      if ( p.length === 7 )
      {
        index = 1 
      }

      p = insertAtIndex( p , "," , index )
    }

    return  p ;

  }

  function setComma( p )
  {
    p = p + ".00";

    //console.log( p ) ;


    var v = p.indexOf(".") ;

    p = p.substring( 0 , v + 3 )

    if ( v > 3 )
    {
      //1999.00

      var index = 2 ;

      if ( p.length === 7 )
      {
        index = 1 
      }

      p = insertAtIndex( p , "," , index )
    }

    return p ;

  }

  function insertAtIndex(str, substring, index) {
    return str.slice(0, index) + substring + str.slice(index);
  }


  
  

  return (



    <div className='d-flex  '>

      <div>
        <FontAwesomeIcon className='pt-2 ps-2' onClick={setClose} icon={faXmarkCircle} 
                title='Close Companies' 
                style={{color:'grey' , height:25 , display:'inline'}}/>
      </div>

      <div className='pt-5'>
        <p>sku = {showProduct.sku}</p>
        <p>price = {"$"+getDecimals((fullData.price*17.0959)*1.16)}</p>
        { fullData.pricepromo !== undefined && (<p>pricepromo = {"$"+setComma(fullData.pricepromo)}</p>)}
        <p>titlesp = {fullData.titlesp}</p>
        { ( fullData.warranty !== "" ) &&  (<p>Garantia = {fullData.warranty}</p>)}
        { fullData.availabilitysp && ( <p>Disponibilidad = {fullData.availabilitysp}</p>) }
        { fullData.appinfo && ( <p>Info = {fullData.appinfo}</p>) }
        { fullData.oem && ( <p>Oem = {fullData.oem}</p>) }
        { fullData.warnings && ( <a  href={fullData.warnings} target='blank'>Warnings</a>) }
        { fullData.feature && <ShowFeatures items={fullData.feature} ></ShowFeatures> }

        {/* { fullData.feature && ( <p>Features = {fullData.feature}</p>) } */}
        {/* { fullData.title && ( <p>Especificaciones = {fullData.title} : {fullData.description} </p>) } */}
        { fullData.especifications && <ShowEspecifications items={fullData.especifications} ></ShowEspecifications> }
        </div>

        { fullData.image !== null && (
          <div className='w100  text-center'>
                <img src={fullData.image}   alt='' height='400px' style={{backgroundColor:'grey' , cursor:'grab'}}></img>
          </div>

        )


        }



    </div>
  )
}
